import MojitoCore from 'mojito/core';

import {icon} from '#core/utils/style-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {generateToggleButton} from '#core/application/modules/tiles/button/index.js';

const merge = MojitoCore.Presentation.uiStyle.merge;

export function numericKeypadFactory(PALETTE) {
    return {
        ...getNumericKeypadConfig(PALETTE),
        ...getCompactNumericKeypadConfig(PALETTE),
    };
}

function getNumericKeypadConfig(PALETTE) {
    const {FONT} = PALETTE;
    const KEYPAD_BUTTON = merge(generateToggleButton(PALETTE.KEYPAD_BUTTON).unselected, {
        style: {
            base: {
                padding: '0 8px',
            },
        },
    });

    return {
        IncrementalNumericKeypad: {
            increaseButtons: {
                default: {
                    style: {
                        base: {
                            ...resolveBackground(PALETTE.KEYPAD_INCREASE_BUTTON_BG),
                            borderRadius: PALETTE.KEYPAD_BUTTON.TOGGLE_BUTTON_BORDER_RADIUS,
                            padding: '0 8px',
                            fontSize: FONT.SIZE_MEDIUM,
                            ...PALETTE.KEYPAD_BUTTON.TOGGLE_BUTTON_TEXT,
                            ...PALETTE.KEYPAD_INCREASE_BUTTON_TEXT,
                        },
                        active: {
                            ...resolveBackground(PALETTE.KEYPAD_INCREASE_BUTTON_ACTIVE_BG),
                        },
                    },
                },
            },
        },
        NumericKeypad: {
            container: {
                style: {
                    ...resolveBackground(PALETTE.KEYPAD_CONTAINER_BG),
                    padding: '6px 8px',
                    boxShadow: PALETTE.KEYPAD_CONTAINER_SHADOW,
                },
            },
            buttons: {
                default: KEYPAD_BUTTON,
                dot: {
                    style: {
                        base: {
                            boxSizing: 'border-box',
                        },
                    },
                },
                done: {
                    style: {
                        base: {
                            textTransform: PALETTE.KEYPAD_DONE_BUTTON_TEXT_UPPERCASE ? 'uppercase' : 'capitalize',
                        },
                    },
                },
            },
            keypadImageEraseButton: {
                button: KEYPAD_BUTTON,
                activeImage: icon(PALETTE.KEYPAD_BUTTON.TOGGLE_BUTTON_SELECTED_ICON_COLOR),
                inactiveImage: icon(PALETTE.KEYPAD_BUTTON.TOGGLE_BUTTON_ICON_COLOR),
            },
        },
    };
}

function getCompactNumericKeypadConfig(PALETTE) {
    const KEYPAD_COMPACT_BUTTON = generateToggleButton(PALETTE.KEYPAD_COMPACT_BUTTON).unselected;

    return {
        CompactNumericKeypad: {
            container: {
                style: {
                    ...resolveBackground(PALETTE.KEYPAD_COMPACT_CONTAINER_BG),
                },
            },
            buttons: {
                default: KEYPAD_COMPACT_BUTTON,
            },
            keypadImageEraseButton: {
                button: KEYPAD_COMPACT_BUTTON,
                activeImage: icon(PALETTE.KEYPAD_COMPACT_BUTTON.TOGGLE_BUTTON_SELECTED_ICON_COLOR),
                inactiveImage: icon(PALETTE.KEYPAD_COMPACT_BUTTON.TOGGLE_BUTTON_ICON_COLOR),
            },
            keypadImageDoneButton: {
                button: KEYPAD_COMPACT_BUTTON,
                activeImage: icon(PALETTE.KEYPAD_COMPACT_BUTTON.TOGGLE_BUTTON_SELECTED_ICON_COLOR),
                inactiveImage: icon(PALETTE.KEYPAD_COMPACT_BUTTON.TOGGLE_BUTTON_ICON_COLOR),
            },
        },
    };
}
